//Principais
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from "angular-datatables";
import { ADTSettings } from "angular-datatables/src/models/settings";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, lastValueFrom } from "rxjs";
//Métodos
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { Polo } from "src/app/shared/models/polo/Polo";
import { Atividade } from 'src/app/shared/models/psicologo/AtividadePsicologo';
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
//Serviços
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";

import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { DashboardAtividadePsicologo } from 'src/app/shared/models/chamados/listar-atividades-psicologos';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
    templateUrl: './dashboard-visitas.component.html',
    styleUrls: ['./dashboard-visitas.component.scss'],
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports],
    standalone: true
})

export class PageDashboardVisitasComponent implements OnInit, OnDestroy {
  //Variaveis de Login
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  // Variaveis do Grid DataTable
  public dtOptions: any = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public isDtInitialized: boolean = false;
  public psicologosInativos: boolean = false;
  data: any[] = []; // Sua fonte de dados
  itemToDelete: any;

  constructor(private spinnerService: NgxSpinnerService,
    private authService: AuthService,
    private psicologoService: PsicologoService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private toastr: ToastrService,
    private escolaService: EscolaService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router

  ) {
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }
  //Forms
  public formDashboard!: FormGroup;
  public get form() { return this.formDashboard.controls; }
  public submitted: boolean;
  public showPesquisa: boolean;

  //Modal
  public showModalConfirmacao: boolean;

  public showModalComentario: boolean;
  public comentarioModal: string;
  public tipoPec: boolean;

  //Listagens
  public polos: Polo[] = [];
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public poloLogado: Polo;
  public lstAtividade: DashboardAtividadePsicologo[] = [];
  public atividadeParaExcluir: number | null = null;


  public async ngOnInit(): Promise<void> {
    ($.fn.dataTable.ext.type.order as any)['date-dd-mm-yyyy-pre'] = (data: string) => {
      const parts = data.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day).getTime();
    };

    this.dtOptions = {
      deferRender: true,
      destroy: false,
      processing: true,
      paging: true,
      dom: 'Bfrtip',
      order: [[3, 'asc']],
      columnDefs: [
        { targets: 3, type: 'date-dd-mm-yyyy' }, // Define a coluna como do tipo personalizado
      ],
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.11.5/i18n/pt-BR.json'
      },
      lengthMenu: [
        [10, 25, 50, -1],
        ['10 linhas', '25 linhas', '50 linhas', 'Tudo']
      ],
      buttons: [
        'pageLength',
        {
          extend: 'print',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7 ]
          }
        },
        {
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7]
          }
        },
        {
          extend: 'pdf',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7 ]
          }
        }
      ],
      // columns: [
      //   { data: 'codigoAtividadePsicologo' },
      //   { data: 'ds_TP_ACAO_ATIVIDADE' },
      //   { data: 'codigoChamado' },
      //   {
      //     data: 'dataAtividadePsicologo',
      //     render: function (data: any, type: any, row: any) {
      //       if (type === 'display' || type === 'filter') {
      //         return moment(data, 'DD/MM/YYYY').format('DD/MM/YYYY'); // Formato de exibição
      //       }
      //       return moment(data, 'DD/MM/YYYY').toDate(); // Formato interno para ordenação
      //     }
      //   },
      //   { data: 'timeAtividadePsicologo' },
      //   { data: 'sT_APROVACAO_PEC' },
      //   { data: 'estrelasAvaliacaoPEC' },
      //   { data: 'professorPOC' },
      //   { data: 'acoes' }
      // ],
    };
    //Formulario de Pesquisa
    this.formDashboard = new FormGroup({
      codigoPolo: new FormControl(null, [Validators.required]),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null),
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null)
    });

  if (this.userLogado?.codigoPerfil === 1477) {
    this.formDashboard.get('codigoPolo')?.clearValidators();
    this.formDashboard.get('codigoDiretoria')?.clearValidators();
  } else {
    this.formDashboard.get('codigoPolo')?.setValidators([Validators.required]);
    this.formDashboard.get('codigoDiretoria')?.setValidators([Validators.required]);
  }

   this.formDashboard.get('codigoPolo')?.updateValueAndValidity();
   this.formDashboard.get('codigoDiretoria')?.updateValueAndValidity();

    if(!this.userLogado?.codigoPolo &&
      this.userLogado?.codigoDiretoria && this.userLogado?.codigoDiretoria > 0){
      await this.getPoloPorDiretoria(this.userLogado?.codigoDiretoria);
      if(this.userLogado?.codigoPolo > 0){
        await this.getDiretoriasEscolasPorPolo(true);
      }else
          this.form.codigoDiretoria.disable();
    }
    if (this.userLogado?.flPsicologo) {
      await this.getPoloDiretoriaPsicologo();
    }
    else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getPolosAdmin();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getPolosPerfilDiretor();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
        await this.getPolosPerfilProfessor();
      }
    }
    await this.getDiretoriasEscolasPorPolo(true);
    await this.PesquisarVisitas(true);

    const currentPage = this.userLogado?.currentPage == undefined ? 0 : this.userLogado?.currentPage;

    // Esperar que la DataTable se haya inicializado completamente
    if (this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        this.goToPage(currentPage);
      }).catch((error) => {
        console.error("Error al inicializar la tabla: ", error);
      });
    }
  }

  public async getPolos() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos())
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polos = response.data;
    this.spinnerService.hide();
  }

  public async getPoloPorDiretoria(codigoDiretoria: number) {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(codigoDiretoria))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.poloLogado = response.data[0];
    if (this.userLogado) {
      this.userLogado.codigoPolo = response.data[0].codigoPolo == null ? 0 : response.data[0].codigoPolo;
      this.authService.setUser(this.userLogado);
    }
    this.spinnerService.hide();
  }

  public OnChangePolo() {

    const codigoPolo = this.formDashboard.get('codigoPolo')?.value;
    if (this.userLogado !== null) {
      this.userLogado.codigoPolo = codigoPolo == null ? 0 : codigoPolo;
      this.authService.setUser(this.userLogado);
    }

    if (codigoPolo != null) {
      this.getDiretoriasPorPolo();
    } else {
      this.zerarDiretoria();
    }
    this.zerarEscola();
  }



  public async getDiretoriasPorPolo(diretoriaLogada: boolean = false) {
    if (this.userLogado?.codigoPolo) {
      this.zerarDiretoria();
      this.spinnerService.show();
      const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        // this.showPesquisa = false;
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.diretorias = response.data;
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
      this.getEscolasPorDiretoria();
      this.spinnerService.hide();
    }

    if (this.userLogado !== null) {
      this.userLogado.codigoDiretoria = this.userLogado.codigoDiretoria == null ? 0 : this.userLogado.codigoDiretoria;
      this.authService.setUser(this.userLogado);
    }
  }

  public zerarDiretoria() {
    this.diretorias = [];
    this.formDashboard.get('codigoDiretoria')?.patchValue(null);
  }

  public async trocaDiretoria() {

    const codigoDiretoria = this.formDashboard.get('codigoDiretoria')?.value;
    if (this.userLogado !== null && codigoDiretoria != null) {
      this.userLogado.codigoDiretoria = codigoDiretoria == null ? 0 : codigoDiretoria;
      this.authService.setUser(this.userLogado);
    }
    if (codigoDiretoria != null)
      await this.getEscolasPorDiretoria();
    else
      this.escolas = [];
    this.form.codigoEscola.setValue(null);
  }
  onChangeEscola() {
    const codigoEscola = this.formDashboard.get('codigoEscola')?.value;
    if (this.userLogado !== null && codigoEscola != null) {
      this.userLogado.codigoEscola = codigoEscola == null ? 0 : codigoEscola;
      this.authService.setUser(this.userLogado);
    }
  }

  public async getDiretoriasEscolasPorPolo(inicio = false) {
    this.spinnerService.show();

    if (this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0) {

      const response = await lastValueFrom(this.psicologoService.getDiretoriaEscolasPorPolo(this.userLogado!.codigoPolo))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.diretorias = response.data.diretorias;
      await this.getEscolasPorDiretoria(inicio);
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
    }

    this.spinnerService.hide();
  }

  public async getEscolasPorDiretoria(inicio = false) {
    if (this.userLogado !== null && !inicio) {
      this.userLogado.codigoEscola = this.form.codigoDiretoria.value == null ? 0 : this.userLogado.codigoEscola;
      this.authService.setUser(this.userLogado);
    }
    if (this.userLogado?.codigoDiretoria && this.userLogado.codigoDiretoria > 0) {
      this.form.codigoDiretoria.setValue(this.userLogado?.codigoDiretoria);
    }
    if (this.form.codigoDiretoria.value) {

      this.spinnerService.show();
      this.zerarEscola();
      const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(this.form.codigoDiretoria.value))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.escolas = response.data;
      this.ativaEscola();
      this.spinnerService.hide();
    }

  }

  public zerarEscola() {
    this.escolas = [];
    this.formDashboard.get('codigoEscola')?.patchValue(null);
  }

  public ativaEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola != undefined) {
        this.formDashboard.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
      }

    }
  }

  public ativaDiretoria() {
    const diretoria = this.diretorias.filter(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria);

    if (this.userLogado?.codigoDiretoria && this.userLogado?.codigoDiretoria > 0 && diretoria.length > 0) {
      this.formDashboard.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
    }

    const polo = this.polos.filter(s => s.codigoPolo == this.userLogado?.codigoPolo);
    if (this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0 && polo.length > 0) {
      this.formDashboard.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);
    }
  }

  public SetParametrosAtividade(): Atividade {
    const atividade = new Atividade();
    atividade.codigoPolo = this.form?.codigoPolo.value;
    atividade.codigoDiretoria = this.form?.codigoDiretoria.value;
    atividade.codigoEscola = this.form?.codigoEscola.value;
    atividade.dataInicio = this.form?.dataInicio.value;
    atividade.dataFim = this.form?.dataFim.value;
    atividade.psicologosInativos = this.psicologosInativos;
    return atividade;
  }

  public getDate(data?: Date) {
    if (data == undefined) return;
    return formatDate(data, 'dd/MM/yyyy', this.locale);
  }
  public ngOnDestroy(): void {
    // this.dtTrigger.unsubscribe();
  }
  public AbreFechaModalConfirmacao(codigoAtividade?: number) {
    if (codigoAtividade !== undefined) {
      this.atividadeParaExcluir = codigoAtividade;
    }
    this.showModalConfirmacao = !this.showModalConfirmacao;
  }
  public async ExcluirAtividadePsicologo() {
    if (this.atividadeParaExcluir !== null) {
      this.spinnerService.show();

      const response = await lastValueFrom(this.psicologoService.setExcluirAtividadePsicologo(this.atividadeParaExcluir))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.atividadeParaExcluir = null;
      this.toastr.success("Atividade excluida com sucesso!");
      this.atividadeParaExcluir = null;
      this.PesquisarVisitas();
      this.AbreFechaModalConfirmacao();
    }
  }
  public async PesquisarVisitas(flagInit: boolean = false) {

    this.spinnerService.show();



    if (this.userLogado !== null && !flagInit) {
      this.userLogado.codigoEscola = this.form.codigoEscola.value == null ? 0 : this.form.codigoEscola.value;
      this.userLogado.codigoDiretoria = this.form.codigoDiretoria.value == null ? 0 : this.form.codigoDiretoria.value;
      this.userLogado.codigoPolo = this.form.codigoPolo.value == null ? 0 : this.form.codigoPolo.value;
      this.authService.setUser(this.userLogado);

    }

    this.submitted = true;
    if (this.formDashboard.invalid) {
      this.showPesquisa = false;
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametrosAtividade();
    const response = await lastValueFrom(this.psicologoService.getDashboardAtividadePsicologos(parametros)).catch((err) => {
      this.spinnerService.hide();
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
    }
    this.spinnerService.hide();

    this.lstAtividade = response.data;

    if (this.lstAtividade.length == 0) {
      this.showPesquisa = false;
      this.toastr.warning("Não existem atividades para essa pesquisa");
      if (this.dtElement.dtInstance != null) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy(); // Linha 1: Destruição do DataTable
          this.dtTrigger.next(this.dtOptions);
        });
      }
    } else {
      if (this.isDtInitialized) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy(); // Linha 2: Destruição do DataTable
          this.dtTrigger.next(this.dtOptions);
        });
      } else {
        this.isDtInitialized = true;
        if (this.dtElement.dtInstance != null) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy(); // Linha 3: Destruição do DataTable
          });
        }
        this.dtTrigger.next(this.dtOptions);
      }
    }

    const currentPage = this.userLogado?.currentPage == undefined ? 0 : this.userLogado?.currentPage;
    if (this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        this.goToPage(currentPage);
      }).catch((error) => {
        console.error("Error al inicializar la tabla: ", error);
      });
    }

    this.showPesquisa = true;

  }

  public AbrirAprovacao(item: any) {
    this.getActivePage();
    this.router.navigate(['/aprovacao-visitas-psicologo/', item.codigoAtividadePsicologo]);
  }
  public AbrirVisualizar(item: any) {
    this.getActivePage();
    this.router.navigate(['/visualizar-atividade-psicologo/', item.codigoAtividadePsicologo]);
  }

  public async getPoloDiretoriaPsicologo() {
    const response = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado!.cpf)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    const polosRetorno = Array.isArray(response.data) ? response.data : [response.data];
    this.aplicarRegraPolos(polosRetorno);

    if (this.polos.length === 1) {
      await this.getDiretoriasPorPolo();
    } else {
      this.zerarDiretoria();
      this.zerarEscola();
      this.form.codigoDiretoria.disable();
      this.form.codigoEscola.disable();
    }
  }

  public async getPolosAdmin() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos());

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.aplicarRegraPolos(response.data);

    if (this.polos.length === 1) {
      await this.getDiretoriasPorPolo(true);
    }

    this.spinnerService.hide();
  }

  public async getPolosPerfilDiretor() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos()).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.aplicarRegraPolos(response.data);

    if (this.polos.length === 1 && this.userLogado?.DadosUsuario[0].CodigoDiretoria != 0) {
      const todasDiretoriasDoUsuario: Diretoria[] = [];
      this.userLogado?.DadosUsuario.forEach(item => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        todasDiretoriasDoUsuario.push(diretoria);
      });
      this.diretorias = todasDiretoriasDoUsuario;

      if (this.diretorias.length == 1) {
        this.form.codigoDiretoria.setValue(this.userLogado?.DadosUsuario[0].CodigoDiretoria);
      } else {
        this.form.codigoDiretoria.enable();
      }

      this.form.codigoEscola.enable();
      await this.getEscolasPorDiretoria();
    } else {
      this.zerarDiretoria();
      this.zerarEscola();
      this.form.codigoDiretoria.disable();
      this.form.codigoEscola.disable();
    }

    this.spinnerService.hide();
  }

  public async getPolosPerfilProfessor() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos()).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.aplicarRegraPolos(response.data);

    if (this.polos.length === 1) {
      const diretoriasEx: Diretoria[] = [];
      const escolasEx: Escola[] = [];
      const dadosUsuario = this.userLogado?.DadosUsuario[0];

      if (dadosUsuario?.CodigoDiretoria != 0 && dadosUsuario?.CodigoEscola != 0) {
        this.userLogado?.DadosUsuario.forEach(item => {
          const diretoria = new Diretoria();
          diretoria.codigoDiretoria = item.CodigoDiretoria;
          diretoria.nomeDiretoria = item.NomeDiretoria;
          diretoriasEx.push(diretoria);

          const escola = new Escola();
          escola.codigoEscola = item.CodigoEscola;
          escola.nomeEscola = item.NomeEscola;
          escolasEx.push(escola);
        });

        this.diretorias = diretoriasEx;
        this.escolas = escolasEx;

        this.form.codigoDiretoria.setValue(this.userLogado?.codigoDiretoria);
        if (this.diretorias.length === 1) this.form.codigoDiretoria.disable();

        this.form.codigoEscola.setValue(this.userLogado?.codigoEscola);
        if (this.escolas.length === 1) this.form.codigoEscola.disable();
      }
    } else {
      this.zerarDiretoria();
      this.zerarEscola();
      this.form.codigoDiretoria.disable();
      this.form.codigoEscola.disable();
    }

    this.spinnerService.hide();
  }

  public ativaPolo() {
    if (this.userLogado?.codigoPolo != undefined)
      this.formDashboard.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);

    if (this.userLogado !== null && this.userLogado)
      this.authService.setUser(this.userLogado);
  }

  public getAprovacaoStatus(status: number | null): string {
    if (status === 1) {
      return 'Aprovado';
    } else if (status === 2) {
      return 'Aprovado com melhoria';
    } else if (status === 3) {
      return 'Não Aprovado';
    } else if (status === null){
      return 'Não Analisado';
    }
    return '';
  }

  public displayComentario(comentario: string, tipoPEC: boolean){
    if (comentario === null) {
      this.toastr.error('Sem comentário');
    }
    this.showModalComentario = true;
    this.tipoPec = tipoPEC;
    this.comentarioModal = comentario;
  }

  public FecharModalComentario() {
    this.showModalComentario = false;
  }

  // Novo método para obter a página ativa
  public getActivePage(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const activePage = dtInstance.page();
        if (this.userLogado) {
          this.userLogado.currentPage = activePage;
          this.authService.setUser(this.userLogado);
        }
      });
    }
  }

  // Novo método para mover-se para uma página específica
  goToPage(page: number) {
    // Si la tabla no está inicializada, espera 100 ms y vuelve a intentar.
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Cambio de página después de un pequeño retraso
        setTimeout(() => {
          dtInstance.page(page).draw('page');
        }, 500); // Aquí el retraso es de 500ms
      }).catch((error) => {
        console.error("Error al inicializar la tabla: ", error);
      });
    } else {
      setTimeout(() => this.goToPage(page), 500); // Intentar de nuevo después de 500ms
    }
  }

  public OnChangePsicologosInativos() {
    this.psicologosInativos = !this.psicologosInativos;
    this.PesquisarVisitas();
  }

  private obterCodigosPolosVinculadosUsuario(): number[] {
    const dadosUsuario = this.userLogado?.DadosUsuario ?? [];

    const codigos = dadosUsuario
      .map((item: any) => Number(item?.CodigoPolo ?? item?.codigoPolo ?? 0))
      .filter((codigo: number) => codigo > 0);

    if (codigos.length === 0) {
      return [];
    }

    const codigoPoloLogin = Number(this.userLogado?.codigoPolo ?? 0);
    if (codigoPoloLogin > 0) codigos.push(codigoPoloLogin);

    return [...new Set(codigos)];
  }

  private aplicarRegraPolos(polosRetornados: Polo[]): void {
    const codigosVinculados = this.obterCodigosPolosVinculadosUsuario();

    this.polos = (polosRetornados ?? []).filter((p: Polo) =>
      codigosVinculados.length === 0 || codigosVinculados.includes(Number(p.codigoPolo))
    );

    const ctrl = this.formDashboard.get('codigoPolo');
    if (!ctrl) return;

    if (this.polos.length > 1) {
      ctrl.enable({ emitEvent: false });
      const atual = Number(this.userLogado?.codigoPolo ?? 0);
      const valido = this.polos.some(p => Number(p.codigoPolo) === atual);
      ctrl.setValue(valido ? atual : null, { emitEvent: false });
      return;
    }

    if (this.polos.length === 1) {
      const unico = Number(this.polos[0].codigoPolo);
      ctrl.setValue(unico, { emitEvent: false });
      ctrl.disable({ emitEvent: false });

      if (this.userLogado) {
        this.userLogado.codigoPolo = unico;
        this.authService.setUser(this.userLogado);
      }
      return;
    }

    ctrl.setValue(null, { emitEvent: false });
    ctrl.enable({ emitEvent: false });
  }
}
